/**
 * Analytics event tracker — sends events to Worker /api/analytics/event
 * Batches events and sends every 5 seconds or on page unload.
 */
const API = 'https://api.genofx.com';
const BATCH_INTERVAL = 5000;
let queue: any[] = [];
let timer: ReturnType<typeof setTimeout> | null = null;

function getSessionId(): string {
  let sid = sessionStorage.getItem('gfx_sid');
  if (!sid) { sid = crypto.randomUUID(); sessionStorage.setItem('gfx_sid', sid); }
  return sid;
}

function getUserId(): string | null {
  try {
    const u = localStorage.getItem('genofx:user');
    if (u) return JSON.parse(u).id || JSON.parse(u).cognito_username || null;
  } catch {}
  return null;
}

export function track(event: string, properties?: Record<string, any>, page?: string) {
  queue.push({
    event,
    properties: properties || {},
    page: page || window.location.pathname.split('/')[1] || 'home',
    user_id: getUserId(),
    session_id: getSessionId(),
  });

  if (!timer) {
    timer = setTimeout(flush, BATCH_INTERVAL);
  }
}

function flush() {
  timer = null;
  if (queue.length === 0) return;
  const batch = queue.splice(0, 50);
  const token = localStorage.getItem('genofx:token');
  fetch(`${API}/api/analytics/batch`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ events: batch }),
    keepalive: true,
  }).catch(() => {});
}

// Flush on page unload
if (typeof window !== 'undefined') {
  window.addEventListener('visibilitychange', () => { if (document.visibilityState === 'hidden') flush(); });
  window.addEventListener('beforeunload', flush);
}

// Auto-track page views on route change
let lastPath = '';
export function trackPageView() {
  const path = window.location.pathname;
  if (path !== lastPath) {
    lastPath = path;
    track('page_view', { path, referrer: document.referrer });
  }
}
